/* =============================================================
   AADHAV – TOURNAMENT EXPENSE CATEGORY SELECTORS
   Production Ready
============================================================= */

/**
 * =============================================================
 * BASE STATE
=============================================================
 */

export const selectTournamentExpenseCategoriesState = (state) =>
  state?.admin?.tournamentExpenseCategories ?? {};

/**
 * =============================================================
 * CATEGORY LIST
=============================================================
 */

export const selectExpenseCategories = (state) => {
  const data =
    selectTournamentExpenseCategoriesState(state).categories;

  if (!Array.isArray(data)) {
    console.warn("⚠️ Categories is not array:", data);
    return [];
  }

  return data;
};

/**
 * =============================================================
 * LOADING
=============================================================
 */

export const selectExpenseCategoriesLoading = (state) =>
  Boolean(
    selectTournamentExpenseCategoriesState(state).loading
  );

/**
 * =============================================================
 * ERROR
=============================================================
 */

export const selectExpenseCategoriesError = (state) =>
  selectTournamentExpenseCategoriesState(state).error ?? null;

/**
 * =============================================================
 * META
=============================================================
 */

export const selectExpenseCategoriesMeta = (state) => {
  const meta =
    selectTournamentExpenseCategoriesState(state).meta;

  return {
    total: meta?.total ?? 0,
    total_pages: meta?.total_pages ?? 1,
    page: meta?.page ?? 1,
    limit: meta?.limit ?? 10,
  };
};

/**
 * =============================================================
 * SELECTED CATEGORY
=============================================================
 */

export const selectSelectedExpenseCategory = (state) =>
  selectTournamentExpenseCategoriesState(state)
    .selectedCategory ?? null;

/**
 * =============================================================
 * CATEGORY COUNT
=============================================================
 */

export const selectExpenseCategoryCount = (state) =>
  selectExpenseCategories(state).length;

/**
 * =============================================================
 * CATEGORY OPTIONS
 * Perfect for Dropdowns
=============================================================
 */

export const selectExpenseCategoryOptions = (state) =>
  selectExpenseCategories(state).map((category) => ({
    value: category.id,
    label: category.category_name,
  }));

/**
 * =============================================================
 * SORTED CATEGORY LIST
=============================================================
 */

export const selectSortedExpenseCategories = (state) =>
  [...selectExpenseCategories(state)].sort((a, b) =>
    (a.category_name || "").localeCompare(
      b.category_name || ""
    )
  );

/**
 * =============================================================
 * FIND CATEGORY BY ID
=============================================================
 */

export const selectExpenseCategoryById =
  (categoryId) => (state) =>
    selectExpenseCategories(state).find(
      (category) =>
        Number(category.id) === Number(categoryId)
    ) || null;